import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { List, Stack } from '@mui/material';
// locales
import { useLocales } from '../../../locales';
//
import NavList from './NavList';
import { StyledSubheader } from './styles';

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  sx: PropTypes.object,
  data: PropTypes.array,
  onItemClick: PropTypes.func,
};

export default function NavSectionVertical({ data, sx, onItemClick, ...other }) {
  const { translate } = useLocales();

  const [openItems, setOpenItems] = useState({});

  const handleItemClick = (item) => {
    const depth = item.depth ?? 1;

    setOpenItems((prev) => {
      const newState = { ...prev };

      // toggle do nível atual
      newState[depth] =
        prev[depth] === item.title ? null : item.title;

      // 🔥 mantém árvore aberta corretamente
      if (depth === 2) {
        newState[1] = item.parentTitle;
      }

      if (depth === 3) {
        newState[2] = item.parentTitle;
        newState[1] = item.grandParentTitle;
      }

      return newState;
    });

    onItemClick?.(item);
  };

  // 🔥 injeta parent e grandParent
  const injectHierarchy = (items, parent = null, grandParent = null) =>
    items.map((item) => ({
      ...item,
      parentTitle: parent,
      grandParentTitle: grandParent,
      children: item.children
        ? injectHierarchy(item.children, item.title, parent)
        : undefined,
    }));

  const navData = data.map((group) => ({
    ...group,
    items: injectHierarchy(group.items),
  }));

  return (
    <Stack sx={sx} {...other}>
      {navData.map((group) => {
        const key = group.subheader || group.items[0].title;

        return (
          <List key={key} disablePadding sx={{ px: 2 }}>
            {group.subheader && (
              <StyledSubheader disableSticky>
                {`${translate(group.subheader)}`}
              </StyledSubheader>
            )}

            {group.items.map((list) => (
              <NavList
                key={list.title + list.path}
                data={list}
                depth={list.depth ?? 1}
                hasChild={!!list.children}
                onItemClick={handleItemClick}
                openItems={openItems}
              />
            ))}
          </List>
        );
      })}
    </Stack>
  );
}